<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.confirmationsPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" style="width: 70px;"></th>
            <th scope="col" class="border-0">{{ $t('order.confirmationsPopup.confirmationText') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(confirmation, index) of confirmations"
            :key="'confirmation-' + index">
            <td class="align-middle pl-5 pr-0">
              <d-checkbox
                inline
                v-model="confirmationsList[confirmation.id]"
                toggle
                toggle-small
                class="m-0">
              </d-checkbox>
            </td>
            <td class="align-middle">
              {{ confirmation.name }}
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        theme="danger"
        class="mr-auto"
        @click.prevent="handleClose">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        theme="success"
        class="ml-auto"
        @click.prevent="saveConfirmations">
        {{ $t('order.confirmationsPopup.iConfirm') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'order-confirmations-popup',
  props: [
    'confirmations'
  ],
  data () {
    return {
      confirmationsList: []
    };
  },
  mounted () {
    for (let i = 0; i < this.confirmations.length; i++) {
      let id = this.confirmations[i].id;
      this.confirmationsList[id] = false;
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-order-confirmations-popup');
    },
    saveConfirmations () {
      let ids = Object.keys(this.confirmationsList);
      let confirmationsToSave = [];
      let notAllConfirmed = false;

      for (let i = 0; i < ids.length; i++) {
        let id = ids[i];
        if (this.confirmationsList[id]) {
          confirmationsToSave.push(id);
        } else {
          notAllConfirmed = true;
        }
      }

      if (notAllConfirmed) {
        Vue.swal({
          title: this.$t('order.confirmationsPopup.notAllConfirmedTitle'),
          html: this.$t('order.confirmationsPopup.notAllConfirmedText'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        return;
      }

      this.$bus.$emit('order-set-order-confirmations', confirmationsToSave);
    }
  }
}
</script>
